import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ParaderoView from "@/pages/ParaderoView";
import ErrorView from "@/pages/ErrorView";
import LandingView from "@/pages/LandingView";
import ItinerarioView from "@/pages/ItinerarioView";
import CercaView from "@/pages/CercaView";
import LlegadasView from "@/pages/LlegadasView";
import AdminShell from "@/pages/admin/AdminShell";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminPanel from "@/pages/admin/AdminPanel";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingView />} />
          <Route path="/paradero" element={<ParaderoView />} />
          <Route path="/itinerario" element={<ItinerarioView />} />
          <Route path="/cerca" element={<CercaView />} />
          <Route path="/llegadas" element={<LlegadasView />} />
          <Route path="/admin" element={<AdminShell />}>
            <Route index element={<Navigate to="login" replace />} />
            <Route path="login" element={<AdminLogin />} />
            <Route path="panel" element={<AdminPanel />} />
          </Route>
          <Route path="*" element={<ErrorView message="Página no encontrada" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;